<template>
  <div class="h-full w-full gap-2 flex items-center">
    <div
      :class="badgeClasses"
      class="h-5 w-5 rounded-md flex items-center justify-center"
    >
      <icon :icon="badgeIcon" :size="IconSize.XXS" class="text-white" />
    </div>
    <span :class="textClasses" class="text-xs font-normal uppercase">
      {{ badgeText }}
    </span>
  </div>
</template>

<script>
import { mdiCheck, mdiClose } from '@mdi/js';
import { Icon, IconSize } from '@/components/Icon';

export default {
  components: {
    Icon,
  },
  data() {
    return {
      IconSize,
    };
  },
  computed: {
    badgeText() {
      return this.params.isAnswered
        ? this.$t('common.yes')
        : this.$t('common.no');
    },
    badgeClasses() {
      return this.params.isAnswered ? 'bg-green' : 'bg-red';
    },
    textClasses() {
      return this.params.isAnswered ? 'text-green' : 'text-red';
    },
    badgeIcon() {
      return this.params.isAnswered ? mdiCheck : mdiClose;
    },
  },
};
</script>
